import React from 'react'
import InputButton from './InputButton'
import Modal from './Modal'
import { UUID } from '@/utils/idGenerator'

export interface CommandPaletteProps {
  id?: string
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  placeholder: string
  autoFocus: boolean
}

const CommandPalette: React.FC<CommandPaletteProps> = ({
  id = UUID(),
  isOpen,
  onOpen,
  onClose,
  placeholder,
  autoFocus,
}) => {
  return (
    <>
      <InputButton id={id} onClick={onOpen} placeholder={placeholder} />
      <Modal
        id={id}
        isOpen={isOpen}
        onClose={onClose}
        autoFocus={autoFocus}
        placeholder={placeholder}
      />
    </>
  )
}

export default CommandPalette
